
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/planner",
      function () {
        return require("private-next-pages/planner.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/planner"])
      });
    }
  